import { flow, types } from 'mobx-state-tree';
import { apiService } from '@services/apiService';
import { withAlertStore } from '@stores/alert/withAlertStore';
import { withMainStore } from '@stores/main/withMainStore';
import { withProfileStore } from '@stores/profile/withProfileStore';
import { filterReqData } from '@utils/prepareData';
import { IChangeStatus } from '@/types/common';
import { ICatalogueListData, IBusinessCatalogueData, ICreateCatalogueReq } from './types';
import { mockCataloguePages, mockCataloguesList } from './mock';
import { ICatalogueForm } from '@/forms/CatalogueForm/types';

const { model, maybeNull, frozen } = types;

export const CataloguesStore = model('CataloguesStore', {
  cataloguesList: maybeNull(frozen<ICatalogueListData[]>()),
  catalogue: maybeNull(frozen<IBusinessCatalogueData>()),
})
  .extend(withAlertStore)
  .extend(withMainStore)
  .extend(withProfileStore)
  .views((self) => ({}))
  .actions((self) => ({
    setCataloguesList(data: ICatalogueListData[]) {
      self.cataloguesList = data;
      return data;
    },
    setCatalogue(data: IBusinessCatalogueData) {
      self.catalogue = data;
      return data;
    },
  }))
  .actions((self) => ({
    getCataloguesList: flow(function* (brandId: string) {
      console.warn('getCataloguesList Using mock data for catalogues list');
      return new Promise<ICatalogueListData[]>((resolve) => {
        resolve(mockCataloguesList);
      }).then((data) => {
        return self.setCataloguesList(mockCataloguesList);
      });
      // return yield apiService
      //   .get(`catalogue-list/${brandId}`)
      //   .then(({ data: { data } }) => {
      //     return self.setCataloguesList(data);
      //   })
      //   .catch(self.mainStore.errorHandling);
    }),
    getCatalogue: flow(function* ({ id, status }: IChangeStatus) {
      const catalogue = mockCataloguesList.find((catalogue) => catalogue.id === id);
      if (catalogue) {
        self.setCatalogue({ ...catalogue, pages: mockCataloguePages, countryCode: 'SVN' });
      }
      return {};
      // return yield apiService
      //   .get(`catalogue/show/${id}?status=${status}`)
      //   .then(({ data: { data } }) => {
      //     return self.setCatalogue(data);
      //   })
      //   .catch(self.mainStore.errorHandling);
    }),
    addCatalogue: flow(function* (data: ICatalogueForm) {
      const { json, isNeedValidation, ...filtred } = data;
      const newData: ICreateCatalogueReq = {
        ...filtred,
        previewUrl: json?.previewUrl || '',
        pages: json?.pages || [],
      };
      return yield apiService
        .post('newspaper/create', filterReqData(newData))
        .catch(self.mainStore.errorHandling);
    }),
    editCatalogue: flow(function* (data: ICatalogueForm) {
      const { json, isNeedValidation, ...filtred } = data;
      const newData: ICreateCatalogueReq = {
        ...filtred,
        previewUrl: json?.previewUrl || '',
        pages: json?.pages || [],
      };
      return yield apiService
        .patch(`newspaper/update/${data.id}`, filterReqData(newData))
        .catch(self.mainStore.errorHandling);
    }),
    // changeStatus: flow(function* ({ id, status }: IChangeStatus) {
    //   return yield apiService
    //     .patch(`point/update-status/${id}`, { status })
    //     .then(({ data: { data } }) => {
    //       return self.setPoint(data);
    //     })
    //     .catch(self.mainStore.errorHandling);
    // }),
  }));
